import React from 'react'
import classNames from 'classnames'

import styles from './index.module.css'

const GroupPanel = ({ children, expanded }) => {
  const toggleFilterContainerStyle = classNames({
    [styles.filterGroupContainer]: true,
    [styles.filterGroupContainerOpen]: expanded
  })

  return (
    <div
      className={toggleFilterContainerStyle}
      aria-label={expanded ? 'Collapse filter' : 'Expand filter'}
    >
      {expanded ? children : null}
    </div>
  )
}

export default GroupPanel
